document.addEventListener("DOMContentLoaded", function() {
  const productRecommendationsSection = document.querySelector('.biw-product-recommendations');

  if (productRecommendationsSection) {
    const url = productRecommendationsSection.dataset.url;
    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.biw-product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
          document.dispatchEvent(new CustomEvent('recommendations:loaded', {
            detail: {
              section: productRecommendationsSection
            }
          }));
        }
      })
      .catch(e => {
        console.error(e);
      });
  }
});